import React from "react";
import clsx from "clsx";
import RoleBuilderErrors from "../RoleBuilderErrors";

export default class RoleBuilderPermissions extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "permissions",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="permissions">
        {this.renderErrors()}
        {this.props.modifying_self && !this.props.read_only ? (
          <div className="alert alert-warning text-center">
            <strong>{I18n.t("users_cannot_edit_their_own_permissions")}</strong>
          </div>
        ) : null}

        {this.props.owner && !this.props.modifying_self ? (
          <div className="alert alert-warning text-center">
            <strong>{I18n.t("the_owner_role_cannot_be_modified")}</strong>
          </div>
        ) : null}

        <div className="row">
          <div className="col-md-12">{this.renderMenuItems()}</div>
        </div>
      </div>
    );
  }

  renderErrors() {
    var errors = RoleBuilderErrors.permissions(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderMenuItems() {
    var self = this;
    const can_edit =
      self.props.read_only || self.props.modifying_self || self.props.owner;
    if (this.props.menu_items && this.props.menu_items.length > 0) {
      var menu_items = this.props.menu_items.map(function (role) {
        return (
          <div key={role.id} className="user-role form-horizontal">
            <div className="form-group">
              <div className="col-sm-2">
                <label className="control-label">{I18n.t(role.name)}</label>
              </div>
              <div className="col-sm-10 permission-block">
                <div className="radio">
                  {can_edit ? (
                    <div
                      className={
                        self.hasRolePrivilege(role, "full_access")
                          ? "has-role-privilege"
                          : "does-not-have-role-privilege"
                      }
                    >
                      {self.hasRolePrivilege(role, "full_access") ? (
                        <span className="checkmark">✓</span>
                      ) : (
                        <span
                          className="checkmark"
                          style={{ visibility: "hidden" }}
                        >
                          ✓
                        </span>
                      )}{" "}
                      {I18n.t("full_access")}
                    </div>
                  ) : (
                    <div>
                      <input
                        type="radio"
                        value="full_access"
                        name={role.name}
                        checked={self.hasRolePrivilege(role, "full_access")}
                        onChange={self.onChange.bind(self, role, "full_access")}
                        disabled={self.props.read_only}
                      />{" "}
                      {I18n.t("full_access")}
                    </div>
                  )}
                </div>
                <div className="radio">
                  {can_edit ? (
                    <div
                      className={
                        self.hasRolePrivilege(role, "view_only")
                          ? "has-role-privilege"
                          : "does-not-have-role-privilege"
                      }
                    >
                      {self.hasRolePrivilege(role, "view_only") ? (
                        <span className="checkmark">✓</span>
                      ) : (
                        <span
                          className="checkmark"
                          style={{ visibility: "hidden" }}
                        >
                          ✓
                        </span>
                      )}{" "}
                      {I18n.t("view_only")}
                    </div>
                  ) : (
                    <div>
                      <input
                        type="radio"
                        value="view_only"
                        name={role.name}
                        checked={self.hasRolePrivilege(role, "view_only")}
                        onChange={self.onChange.bind(self, role, "view_only")}
                        disabled={self.props.read_only}
                      />{" "}
                      {I18n.t("view_only")}
                    </div>
                  )}
                </div>
                <div className="radio">
                  {can_edit ? (
                    <div
                      className={
                        self.hasRolePrivilege(role, "hide") ||
                        self.props.role_resources.length == 0
                          ? "has-role-privilege"
                          : "does-not-have-role-privilege"
                      }
                    >
                      {self.hasRolePrivilege(role, "hide") ||
                      self.props.role_resources.length == 0 ? (
                        <span className="checkmark">✓</span>
                      ) : (
                        <span
                          className="checkmark"
                          style={{ visibility: "hidden" }}
                        >
                          ✓
                        </span>
                      )}{" "}
                      {I18n.t("hide")}
                    </div>
                  ) : (
                    <div>
                      <input
                        type="radio"
                        value="hide"
                        name={role.name}
                        checked={
                          self.hasRolePrivilege(role, "hide") ||
                          self.props.role_resources.length == 0
                        }
                        onChange={self.onChange.bind(self, role, "hide")}
                        disabled={self.props.read_only}
                      />{" "}
                      {I18n.t("hide")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      });

      return <div className="roles">{menu_items}</div>;
    } else {
      return (
        <div className="text-center">
          <em>{I18n.t("none")}</em>
        </div>
      );
    }
  }

  hasRolePrivilege(resource, access) {
    var matched = false;

    for (var i = 0, ilen = this.props.role_resources.length; i < ilen; i++) {
      if (this.props.role_resources[i].menu_item_id == resource.id) {
        matched = this.props.role_resources[i];
        break;
      }
    }
    if (matched) {
      if (matched.access == access) {
        return true;
      } else {
        return false;
      }
    } else {
      if (access == "hide") {
        return true;
      } else {
        return false;
      }
    }
  }

  onChange(resource, access) {
    var role_resource = {
      menu_item_name: resource.name,
      menu_item_id: resource.id,
      access: access,
    };

    // find matched role index
    var matched_index = -1;
    for (var i = 0, ilen = this.props.role_resources.length; i < ilen; i++) {
      if (this.props.role_resources[i].menu_item_id == resource.id) {
        matched_index = i;
        break;
      }
    }

    if (matched_index >= 0) {
      this.props.role_resources[matched_index] = role_resource;
    } else {
      this.props.role_resources.push(role_resource);
    }
    this.props.onChangeResources(this.props.role_resources);
  }
}
